module.exports = __webpack_public_path__ + "img/744.b53bdb3c.jpg";